import { createContext, Dispatch, SetStateAction } from 'react'
import { User, UserPermission, UserProfile } from 'commons/types/user'

export type UserContextType = {
  user: User
  setUser: Dispatch<SetStateAction<User>>
  hasProfile: (...profiles: UserProfile[]) => boolean
  hasPermission: (...permissions: UserPermission[]) => boolean
  isProducer: () => boolean
}

const Context = createContext<UserContextType | null>(null)

Context.displayName = 'UserContext'

const { Provider, Consumer } = Context

export { Provider, Consumer, Context }
